import React from 'react'
import { useGetTyrehubPoint } from '../../api/point'
import { PointDetails } from '../shared/PointDetails'
import { PointsRemaining } from './PointsRemaining'

export const TyrehubPoint = () => {
  return (
    <PointDetails
      title='Tyrehub Trip Point'
      useGetPoint={useGetTyrehubPoint}
      backLink='tyrehub-trip-point'
      accountSummary={[
        {
          id: 'remainingPoints',
          label: 'Points Remaining',
          view: PointsRemaining,
        },
      ]}
      purchaseHistory={[{ label: 'Rim Size', id: 'rimSize' }]}
    />
  )
}
